module.exports = __webpack_public_path__ + "img/logo-min.7c84a0f2.webp";